import { showWizard } from "../../../wizards/RTLWizard";
import NewContactWizard from "../../../wizards/NewContactWizard";
import { update } from "../../../services/DataService";
import { getUser } from "../../../services/UserService";

// returns { contactId, contactName } on success, or null on cancel
export async function OpenNewContactForChat({ chatID, contactPoint }) {
    const defaultCountry = getUser()?.DefaultSettings?.Country || "Australia";

    const pageprops = {
        defaultValues: { Mobile: contactPoint || "" },          // prefill from chat
        contactDetailsRequired: { details: true, address: false },
        userModel: { DefaultSettings: { Country: defaultCountry } },
        viewModel: { entity: { CompanyID: null } }
    };

    // 1) Run wizard
    const result = await showWizard(NewContactWizard, true, pageprops, false, 720);
    if (!result || result.canceled) return null;

    // 2) Extract new ContactID
    const raw = result.Result ?? result;
    const newContactId = Number(raw?.ContactID ?? raw?.ID ?? raw);
    if (!newContactId) return null;

    // 3) Link to this chat
    await update("Chat_LinkContact", { ChatId: chatID, ContactId: newContactId });

    const name = [raw?.FirstName, raw?.LastName].filter(Boolean).join(" ") || null;
    return { contactId: newContactId, contactName: name };
}
